export const host = "https://api.aeter.dk"; //API host
export const cookieAddress = "aeter.dk"; //Web address to save the cookies to
export const cookieSecure = true; //Only https cookies